import Route from "../Route";
import { Switch } from "react-router-dom";

import ProdutoListagem from "../../pages/estoque/produtos/ProdutoListagem";
import ProdutoCadastro from "../../pages/estoque/produtos/ProdutoCadastro";

export default function Estoque() {
  return (
    <>
      <Switch>
        <Route path="/estoque/produto/listagem" component={ProdutoListagem} />
        <Route path="/estoque/produto/cadastro" component={ProdutoCadastro} />
      </Switch>
    </>
  );
}
